// extracted by mini-css-extract-plugin
module.exports = {"Popup":"FeedbackPopup_Popup__ylfFT","PopupContent":"FeedbackPopup_PopupContent__GkeWk","Attempts":"FeedbackPopup_Attempts__k2oRm"};